import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const MiscGrnRejectionViewSingle = () => {
   useAuthRedirect();
    const {poNo, grnNo, oldGrnNo} = useParams();
    const branch = localStorage.getItem("branch");
    const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);
    const [subDetails, setSubDetails] = useState({})

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscgrnReject_detailsHeader?grnNo=${grnNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnheader_date: items[0].grnheader_date || "N/A",
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate || "N/A",
                grnheader_suppliercode: items[0].grnheader_suppliercode || "N/A",
                grnheader_invoiceNumber: items[0].grnheader_invoiceNumber || "N/A",
                grnheader_invoiceDate: items[0].grnheader_invoiceDate || "N/A",
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [grnNo, branch]); 

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.grnheader_suppliercode}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_code : items[0].supplierMaster_code || "N/A",
                supplierMaster_name : items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.grnheader_suppliercode]); 



  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/miscgrnReject_detailsBottom?branch=${branch}&grnNo=${grnNo}`)
      .then((response) => {
        if (response.data && response.data.headerDetails2) {
          setData(response.data.headerDetails2);
          console.log(response.data.headerDetails2);          
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]); 
      });
  }, [branch, grnNo]);
  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                                                            <h2 className="add-txt">Misc GRN Rejection View</h2>
                                                            <Link to='/inventory/miscBillPassingGrnRejectionView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={grnNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_date ? 
         new Date(poDetail.grnheader_date).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="scode" value={poNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Old GRN No :</label>
                <input type="text" name="sname" value={oldGrnNo} readOnly/>
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.grnheader_invoiceNumber} readOnly/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_invoiceDate ? 
         new Date(poDetail.grnheader_invoiceDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={subDetails.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={subDetails.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Acc Qty</th>
                  </tr>
                </thead>
                <tbody>
  {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.grnDetail_itemName}</td>
        <td>{item.grnDetail_uom}</td>
        <td>{item.grnDetail_poPendingQuantity}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_acceptedQuantity}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>
              </table>
            </div>        
          </form>    
        </div>  
      </div>
    </div>
  );
};

export default MiscGrnRejectionViewSingle;
